import { render, staticRenderFns } from "./TheOrganizationList.vue?vue&type=template&id=68a6f43e&"
import script from "./TheOrganizationList.vue?vue&type=script&lang=js&"
export * from "./TheOrganizationList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports